const getCustomShortDateFormat = (date, locale) => {
  const dateFormat = Intl.DateTimeFormat(locale, { day: "numeric", month: "short" });
  return dateFormat.format(date);
};
export {
  getCustomShortDateFormat
};
//# sourceMappingURL=get-custom-short-date-format.js.map
